import { Route } from '@angular/router';
import { authRoutes } from './modules/auth/auth.routes';
import { dashboardRoutes } from './modules/dashboard/dashboard.routes';
import { errorRoutes } from './modules/errors/error.routes';
import { playerRoutes } from './modules/players/player.routes';
import { financialsRoutes } from './modules/financials/financials.routes';
import { usersRoutes } from './modules/users/users.routes';
import { settingsRoutes } from './modules/settings/settings.routes';
import { reportRoutes } from './modules/reports/reports.routes';
import { promotionalRoutes } from './modules/promotional/promotional.routes';
import { emailRoutes } from './modules/email/email.routes';
import { testRoutes } from './modules/test/test.routes';
import { casinoRoutes } from './modules/casino/casino.routes';
import { freeChipsCampaignRoutes } from './modules/free-chips-campaign/free-chips-campaign.routes';
import { freeSpinCampaignRoutes } from './modules/free-spin-campaign/free-spin-campaign.routes';
// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/dashboard'
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Redirect signed-in user to the '/dashboard'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },
    ...errorRoutes,
    ...authRoutes,
    ...dashboardRoutes,
    ...usersRoutes,
    ...playerRoutes,
    ...reportRoutes,
    ...financialsRoutes,
    ...casinoRoutes,
    ...settingsRoutes,
    ...promotionalRoutes,
    ...freeChipsCampaignRoutes,
    ...freeSpinCampaignRoutes,
    ...emailRoutes,
    ...testRoutes,
];
